import React, { useEffect, useState } from 'react';
import { groupBy } from 'lodash';
import { useConsolidationScoreInadimplencia } from './api/getConsolidationScoreInadimplencia';
import LoadingChart from '@/features/dashboard/components/LoadingChart';
import ColumnChartInadimplenciaVisao from '@/components/Base/ColumnChartInadimplenciaVisao';

const ScoreInadimplenciaCategoriaVisao = ({year, month, setListYears}) => {
  const { data, isFetched, isFetching } = useConsolidationScoreInadimplencia();
  const [yearLocal, setYearLocal] = useState<number | null>(null);


  useEffect(() => {
    if (isFetched) {
      const currentYear = new Date().getFullYear();
      const listYears = Object.keys(groupBy(data, 'ano'))
        .map((item) => Number(item))
        .sort((a, b) => b - a);
      setListYears(listYears);
      if (listYears.length) {
        setYearLocal(year === null ? currentYear : year);
      }
    }
  }, [isFetched, data, year]);

  // const onApplyFilter = (selectedYear) => {
  //   setYear(selectedYear);
  // };


  const selectedData = data?.length ? data?.find((item) => Number(item.ano) === year) : null;

  return (
    <>
      <LoadingChart loading={isFetching} />

      {data?.length && selectedData && (
        <ColumnChartInadimplenciaVisao selectedData={selectedData} />
      )}
    </>
  );
};

export default ScoreInadimplenciaCategoriaVisao;
